import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints';
import Page from "../Page";
import FormPartial from "./FormPartial";
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import CrmUser from '../../models/CrmUser';
import { toast } from 'react-toastify';

const New = (props) => {
  const [crmUser, setCrmUser] = useState(new CrmUser());
  const [createApi] = getApi('createCrmUser');
  const navigate = useNavigate();
  let crmUserObj = new CrmUser();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      navigate("/crm/users");
    } catch(error) {
      crmUserObj.set_api_errors(error.data.data.errors);
      toast.error(error.data.message);
    }
  }

  const onCreateClick = () => {
    try{
      createRecord((new CrmUser(crmUser)).toApiJson());
    } catch(error){
      setCrmUser(new CrmUser(crmUser));
    }
  }

  const onBackClick = () => {
    navigate("/crm/users");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewCrmUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "CRM Users", url: '/crm/users' }, { label: "New CRM User" }]}
    className={'crm-users-page'}
  >
    <PageContentWrapper contentHeading={"Add New CRM User"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial crmUser={crmUser} setCrmUser={setCrmUser}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick}  style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onCreateClick}>Create User</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default New;
